import { useEffect, useState } from "react";

// Largura da viewport, atualizada em tempo real — usado para decidir breakpoints de layout
// (ex.: tabela completa vs. cards) sem depender só de classes Tailwind quando a decisão
// precisa acontecer em JS (trocar o conjunto de colunas, por exemplo).
export function useViewportWidth() {
    const [width, setWidth] = useState(() => (typeof window !== "undefined" ? window.innerWidth : 1280));

    useEffect(() => {
        function onResize() {
            setWidth(window.innerWidth);
        }
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, []);

    return width;
}
